import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useScreen } from '../lib/useScreen';
import CASOS_ONSITE from '../data/casosOnsite';
import DashboardTalabarteriaGA from '../components/DashboardTalabarteriaGA';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', verde:'#1D9E75', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };
const DATO_COLORS = { mango:C.mango, turquesa:C.turquesa, coral:C.coral, verde:C.verde };
const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";

export default function CasoPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { isMobile } = useScreen();
  const caso = CASOS_ONSITE.find(c => c.slug === slug);

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!caso) {
    return (
      <div style={{ background:'#0a0a0a', color:'#fff', fontFamily:font, minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:16 }}>
        <p style={{ fontFamily:serif, fontSize:28 }}>Caso no encontrado</p>
        <button onClick={() => navigate('/nosotros')} style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'12px 32px', fontSize:14, fontWeight:500, cursor:'pointer', fontFamily:font }}>
          ← Volver a Nosotros
        </button>
      </div>
    );
  }

  const isPlaceholder = caso.datos[0]?.num === '—';

  return (
    <div style={{ background:'#0a0a0a', color:'#fff', fontFamily:font, minHeight:'100vh' }}>
      <style>{`
        @keyframes tdCasoPageZoom {
          0% { transform: scale(.08) translateY(80px); opacity: 0; }
          45% { opacity: 1; }
          100% { transform: scale(1) translateY(0); opacity: 1; }
        }
        @keyframes tdCasoPageFade {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>

      <div style={{ animation:'tdCasoPageZoom 1.15s cubic-bezier(.16,.8,.24,1)' }}>

        {/* Hero */}
        <div style={{
          position:'relative', width:'100%', height:isMobile?'60svh':'70vh',
          overflow:'hidden',
        }}>
          <img src={caso.photo} alt={caso.name} style={{
            position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover',
          }} />
          <div style={{
            position:'absolute', inset:0,
            background:'linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.15) 40%, rgba(10,10,10,0.95) 100%)',
          }} />

          {/* Back button */}
          <button onClick={() => navigate('/nosotros')} style={{
            position:'absolute', top:isMobile?16:24, left:isMobile?16:32, zIndex:5,
            display:'flex', alignItems:'center', gap:8,
            background:'rgba(0,0,0,.4)', backdropFilter:'blur(8px)',
            border:'1px solid rgba(255,255,255,.2)', borderRadius:50,
            color:'#fff', fontSize:13, fontWeight:500, padding:'10px 20px',
            cursor:'pointer', fontFamily:font,
          }}>
            ← Nosotros
          </button>

          {/* Title */}
          <div style={{ position:'absolute', left:isMobile?20:48, bottom:isMobile?28:48, right:isMobile?20:'auto', maxWidth:700 }}>
            <div style={{ display:'flex', gap:8, marginBottom:14, flexWrap:'wrap' }}>
              <span style={{ padding:'5px 12px', borderRadius:50, background:'rgba(93,193,185,0.2)', backdropFilter:'blur(8px)', border:'0.5px solid rgba(93,193,185,0.3)', color:'#5dc1b9', fontSize:10, fontWeight:600, letterSpacing:1 }}>
                ⚙️ TRABAJO PRESENCIAL
              </span>
              <span style={{ padding:'5px 12px', borderRadius:50, background:'rgba(0,0,0,0.5)', backdropFilter:'blur(8px)', border:'0.5px solid rgba(255,255,255,0.1)', color:'rgba(255,255,255,0.7)', fontSize:10, fontWeight:500 }}>
                📍 {caso.location}
              </span>
            </div>
            <h1 style={{ fontFamily:serif, fontSize:isMobile?36:56, fontWeight:400, margin:'0 0 8px', lineHeight:1.1, color:'#fff', textShadow:'0 2px 30px rgba(0,0,0,0.4)' }}>
              {caso.name}
            </h1>
            <p style={{ color:C.turquesa, fontSize:isMobile?14:17, fontFamily:font, margin:0 }}>
              {caso.location} · {caso.eyebrow}
            </p>
          </div>
        </div>

        {/* Body */}
        <div style={{ maxWidth:1040, margin:'0 auto', padding:isMobile?'32px 20px 48px':'48px 40px 64px' }}>

          {/* Quote */}
          <div style={{ borderLeft:`3px solid ${C.mango}`, paddingLeft:isMobile?16:24, marginBottom:48 }}>
            <p style={{ fontFamily:serif, fontSize:isMobile?18:22, color:'rgba(255,255,255,0.8)', fontStyle:'italic', lineHeight:1.6, margin:0 }}>
              "{caso.quote}"
            </p>
          </div>

          {/* Datos */}
          <p style={{ fontSize:11, fontWeight:700, letterSpacing:1.8, color:C.verde, margin:'0 0 20px', fontFamily:font }}>
            QUÉ HICIMOS · CON NÚMEROS
          </p>
          {slug === 'talabarteria-ga' ? (
            <div style={{ marginBottom:48 }}>
              <DashboardTalabarteriaGA />
            </div>
          ) : (
            <>
              <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr 1fr':'repeat(4, 1fr)', gap:16, marginBottom:48 }}>
                {caso.datos.map((d, i) => (
                  <div key={i} style={{
                    background:'rgba(255,255,255,.04)', border:'1px solid #26262f',
                    borderRadius:18, padding:isMobile?'20px 16px':'24px 22px',
                    opacity: isPlaceholder ? 0.5 : 1,
                  }}>
                    <p style={{ fontFamily:serif, fontSize:isMobile?32:46, lineHeight:1, margin:'0 0 8px', color:DATO_COLORS[d.color] }}>{d.num}</p>
                    <p style={{ fontSize:13, color:'#8b8a99', lineHeight:1.4, margin:0, fontFamily:font }}>{d.label}</p>
                  </div>
                ))}
              </div>
              {isPlaceholder && (
                <p style={{ fontSize:12, color:'#8b8a99', opacity:.6, margin:'-32px 0 48px', fontStyle:'italic', fontFamily:font }}>
                  * Datos por confirmar — se actualizan con las métricas reales del caso.
                </p>
              )}
            </>
          )}

          {/* Proceso */}
          <p style={{ fontSize:11, fontWeight:700, letterSpacing:1.8, color:C.verde, margin:'0 0 20px', fontFamily:font }}>
            EL PROCESO
          </p>
          <div style={{ display:'flex', flexDirection:'column', gap:14, marginBottom:48 }}>
            {caso.proceso.map((p, i) => (
              <div key={i} style={{
                display:'flex', gap:16, alignItems:'flex-start',
                background:'rgba(255,255,255,.03)', border:'1px solid #26262f',
                borderRadius:16, padding:isMobile?'16px':'20px 24px',
                fontSize:isMobile?14:15, color:'#c9c8d6', fontFamily:font, lineHeight:1.6,
              }}>
                <span style={{ flexShrink:0, fontSize:22 }}>{p.icon}</span>
                <span><b style={{ color:'#e9e8f2' }}>{p.bold}</b> {p.text}</span>
              </div>
            ))}
          </div>

          {/* CTA Video — full width */}
          <a href={caso.videoUrl} target="_blank" rel="noopener noreferrer" style={{
            display:'flex', alignItems:'center', gap:isMobile?16:24,
            background:'rgba(255,255,255,.04)', border:'1px solid rgba(255,255,255,.12)',
            borderRadius:22, padding:isMobile?'24px 20px':'32px 36px',
            textDecoration:'none', marginBottom:48,
            transition:'background .3s, border-color .3s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background='rgba(255,255,255,.08)'; e.currentTarget.style.borderColor='rgba(93,193,185,.3)'; }}
            onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,.04)'; e.currentTarget.style.borderColor='rgba(255,255,255,.12)'; }}
          >
            <span style={{
              flexShrink:0, width:isMobile?56:72, height:isMobile?56:72,
              borderRadius:'50%', background:'rgba(235,99,107,.15)', border:'1px solid rgba(235,99,107,.3)',
              display:'flex', alignItems:'center', justifyContent:'center',
              fontSize:isMobile?28:36, color:C.coral,
            }}>▶</span>
            <div>
              <p style={{ fontSize:isMobile?16:20, fontWeight:600, color:'#e9e8f2', margin:'0 0 4px', fontFamily:font }}>
                Mira cómo lo hicimos — sin cortes
              </p>
              <p style={{ fontSize:isMobile?13:15, color:'#8b8a99', margin:0, fontFamily:font, lineHeight:1.5 }}>
                Errores, aciertos y el detrás de cámaras completo en YouTube
              </p>
            </div>
          </a>

          {/* Back */}
          <div style={{ textAlign:'center' }}>
            <button onClick={() => navigate('/nosotros')} style={{
              background:C.logoGrad, color:'#fff', border:'none', borderRadius:50,
              padding:'14px 36px', fontSize:16, fontWeight:500, cursor:'pointer', fontFamily:font,
              boxShadow:'0 0 30px rgba(93,193,185,0.3)',
              transition:'transform .3s, box-shadow .3s',
            }}
              onMouseEnter={e => { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 0 50px rgba(93,193,185,0.5)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='0 0 30px rgba(93,193,185,0.3)'; }}
            >
              ← Volver a Nosotros
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
